import * as React from 'react';

import * as styles from './FormCardLayout.css';

export const FormCardLayout = ({
  question,
  children,
  image,
}: {
  question: string;
  children: React.ReactNode;
  image: string;
}) => {
  return (
    <div className={styles['card']}>
      <div className={styles['form']}>
        <div className={styles['question']}>{question}</div>
        <div className={styles['content']}>{children}</div>
      </div>
      <div className={styles['image']}>
        <img src={image} alt={question} />
      </div>
    </div>
  );
};
